import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CartWithoutStockPage } from './cart-without-stock.page';
import { ModuleSharedModule } from "../../modules/module-shared.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModuleSharedModule,
  ],
  declarations: [CartWithoutStockPage],
  exports: [CartWithoutStockPage],
})
export class CartWithoutStockPageModule {}
